import { FieldSkeleton } from 'components/secondaryMarket/shared';
import { BlockSkeleton } from 'components/secondaryMarket/shared/Blocks/BlockSkeleton';
import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup';

export function SecondaryProductSummarySkeleton() {
  return (
    <BlockSkeleton id="product-summary" labelSize={15}>
      <form name="marketProductSummary" noValidate autoComplete="off">
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={5} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={8} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={12} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={10} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={10} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={12} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-12">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-12">
            <div className="input-group align-items-baseline flex-nowrap">
              <div className="flex-grow-1">
                <FieldSkeleton />
              </div>
            </div>
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-12">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={8} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>

        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-12">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={8} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={8} className="col-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
      </form>
    </BlockSkeleton>
  );
}
